/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/10/15.
 */

/*eslint handle-callback-err: 0*/

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharedCache = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

var _SharedKey = require('./SharedKey');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Shared Cache
 */
let SharedCache = exports.SharedCache = function () {
  /**
   * @param {AbstractDriver} driver
   */
  function SharedCache(driver) {
    _classCallCheck(this, SharedCache);

    this._driver = driver;

    new _deepCore2.default.Generic.MethodsProxy(this).proxyOverride(this._driver, 'has', 'get', 'set', 'invalidate', 'flush', 'type');
  }

  /**
   * @param {Request} request
   * @returns {Key}
   */


  _createClass(SharedCache, [{
    key: 'buildKeyFromRequest',
    value: function buildKeyFromRequest(request) {
      let action = request.action;
      let microservice = action.resource.microservice;
      let requestIdentifier = action.source[request.isLambda ? 'original' : 'api'];
      let keyString = `${requestIdentifier}#${SharedCache._stringifyPayload(request.payload)}`;

      return new _SharedKey.SharedKey(keyString, microservice);
    }

    /**
     * @param {Runtime} runtime
     * @returns {String}
     */

  }, {
    key: 'buildKeyFromLambdaRuntime',
    value: function buildKeyFromLambdaRuntime(runtime) {
      return runtime.context && runtime.context.has('invokedFunctionArn') ? `${runtime.context.getOption('invokedFunctionArn')}#${SharedCache._stringifyPayload(runtime.request.data)}` : null;
    }

    /**
     * @param {Object} payload
     * @return {String}
     * @private
     */

  }, {
    key: 'assure',


    /**
     * If key exists do nothing, else create it with specified parameters
     *
     * @param {String} key
     * @param {Object} value
     * @param {Number} ttl
     * @param {Function} callback
     */
    value: function assure(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      this._driver.has(key, (err, has) => {
        if (!has) {
          this._driver.set(key, value, ttl, callback);

          return;
        }

        callback(null, true);
      });
    }
  }], [{
    key: '_stringifyPayload',
    value: function _stringifyPayload(payload) {
      return JSON.stringify(SharedCache._normalizeObject(payload));
    }

    /**
     * @param {String} text
     * @param {String} alg
     * @returns {String}
     * @private
     */

  }, {
    key: '_hash',
    value: function _hash(text) {
      let alg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sha1';

      return _crypto2.default.createHash(alg).update(text).digest('hex');
    }

    /**
     * @param {Object} data
     * @returns {Object}
     * @private
     */

  }, {
    key: '_normalizeObject',
    value: function _normalizeObject(data) {
      let normalizedData = {};

      Object.keys(data).sort().forEach(key => {
        let value = data[key];

        if (_util2.default.isArray(value)) {
          value = value.sort();
        } else if (value !== null && typeof value === 'object') {
          value = SharedCache._normalizeObject(value);
        }

        normalizedData[key] = value;
      });

      return normalizedData;
    }
  }]);

  return SharedCache;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/SharedCache.js
// module id = 356
// module chunks = 0